<script>

    import { toast } from 'bulma-toast'
    import { prepaidsStore, prepaidStore, modalStore } from '../stores'

    import PrepaidsService from '../$services/prepaids.service.js'
    import DateMethod from '../$methods/date.method.js'

    import Spinner from '../$components/spinner.svelte'
    import DetailsCard from '../$components/details.card.svelte'
    import DetailsFields from '../$components/details.fields.svelte'
    import DetailsField from '../$components/details.field.svelte'
    import ButtonDelete from '../$components/button.delete.svelte'
    import ButtonModal from '../$components/button.modal.svelte'

    let loading = false

    async function deletePrepaid() {

        loading = true
        const resp = await PrepaidsService.deletePrepaid($prepaidStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        prepaidsStore.remove($prepaidStore._id)
        toast({message: 'Prepago eliminado', type: 'is-success'})
        
        modalStore.close()
    }

    $: prepaidActive = $prepaidStore.shipments.length < $prepaidStore.shipmentsTotal && DateMethod.isAfter($prepaidStore.expired)

</script>

<Spinner {loading} />

{#if !loading}
    <DetailsCard
        title="Prepago"
        meta={DateMethod.dateTimeLarge($prepaidStore.created)}
        statusValue={prepaidActive ? 'Activo' : 'Expiró'}
    >
        <DetailsFields>
            <DetailsField label="Método" value={$prepaidStore.method} />
            {#if $prepaidStore.admin.name}
                <DetailsField label="Admin" value={$prepaidStore.admin.name} />
            {/if}
            <DetailsField label="Proveedor" value={$prepaidStore.provider} />
            <DetailsField label="Servicio" value={$prepaidStore.service} />
            <DetailsField label="Peso" value={`${$prepaidStore.volumetricMin} kg a ${$prepaidStore.volumetricMax} kg`} />
            <DetailsField label="Total" value={ String($prepaidStore.shipmentsTotal) } />
            <DetailsField label="Precio" value={`$${$prepaidStore.shipmentPrice}`} mono />
            <DetailsField label="Cobertura con costo" value={`$${$prepaidStore.coverageCost}`} mono />
            <DetailsField label="Cobertura especial" value={`$${$prepaidStore.coverageSpecial}`} mono />
            <DetailsField label="Usadas" value={ String($prepaidStore.shipments.length) } />
            <DetailsField label="Canceladas" value={ String($prepaidStore.canceled.length) } />
            <DetailsField label="Expira" value={DateMethod.dateTimeLarge($prepaidStore.expired)} />
        </DetailsFields>

        <div slot="footer">
            <div class="is-flex is-justify-content-flex-end is-align-items-center">
                <div class="buttons">
                    <ButtonModal modalId="prepaid_update_modal" icon="edit" text="Actualizar" />
                    <ButtonDelete on:confirm={deletePrepaid} {loading} />
                </div>
            </div>
        </div>
    </DetailsCard>
{/if}
